export default __webpack_public_path__ + "static/lifetime-illustration-643324ed80fc0dc2644471e399e74d58.svg";